import polarCanvas from '../_internal/components/canvases/polar-canvas';
import axisRefVisualPolar from '@fusioncharts/core/src/axis-ref-visuals/axis-ref-polar-component';
// import axisRefVisual from '../components/axis-ref-visuals-polar';
import { componentFactory } from '@fusioncharts/core/src/lib';

/**
 * polarCanvas factory creates polarCanvas for radar chart
 *
 * @export
 * @param {any} chart chartAPI
 */
export default function (chart) {
  let pCanvas;
  componentFactory(chart, polarCanvas, 'canvas', chart.config.showVolumeChart ? 2 : 1);
  pCanvas = chart.getChildren('canvas');
  for (let i = 0, len = pCanvas.length; i < len; i++) {
    pCanvas[i].configure();
    componentFactory(pCanvas[i], axisRefVisualPolar, 'axisRefVisualPolar');
  }
}
